module.exports = __webpack_public_path__ + "static/media/map_bus_icon.471bfa0f.svg";